module.exports = __webpack_public_path__ + "img/arbitration-license.c34ad469.png";